import { ApiError } from "pages/admin-app/shared/models/response/api-errors";
import { GetCountriesResponse } from "../models/response/get-countries-response";
import { getCountries } from "../services/country-service";
import { PER_PAGE } from "pages/admin-app/adminapp.constants";
import { useQuery } from "@tanstack/react-query";

interface Props {
  currentPage: number;
  searchQuery?: string;
}

export function useCountries({ currentPage, searchQuery }: Props) {
  const { data, error, isLoading, isError, refetch, isFetching } = useQuery<
    GetCountriesResponse,
    ApiError
  >({
    queryKey: ["countries", currentPage, searchQuery],
    queryFn: () =>
      getCountries({
        page: currentPage,
        perPage: PER_PAGE,
        searchQuery,
      }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
    isFetching,
  };
}
